import React, { useEffect, useState } from "react";
import { ShimmerPostDetails } from "react-shimmer-effects";

import PageFooter from "@/components/common/PageFooter";
import CommercialHeader from "@/components/pdp/commercial/CommercialHeader";
import SellContactUs from "@/components/sell/ContactUs/SellContactUs";
import PopupSignInUp from "@/components/common/PopupSignInUp";
import MobileMenu from "@/components/common/header/MobileMenu";
import SellHeroSection from "@/components/sell/Hero/SellHeroSection";
import SellStatsSection from "@/components/sell/SellStatsSection/SellStatsSection";
import SellHowItWorks from "@/components/sell/HowItWorksSection/SellHowItWorks";
import MetaComponent from "@/components/common/MetaComponent";
import { getSupportData } from "@/api/faq";
import { generateSellCommercialSchema, injectSchema, removeSchema } from "@/utils/schema";

const metadata = {
  title: "Sell Commercial Properties on Hubzu",
};

const SellPageCommercial = () => {
  const [sellCMSData, setSellSMSData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getCMSData = async () => {
      setLoading(true);
      setError(null);

      try {
        const data = await getSupportData("sellCommercial");
        setSellSMSData(data?.results || []);
      } catch (err) {
        setError("Unable to load content. Please try again later.");
        console.error("Error fetching data: ", err);
      } finally {
        setLoading(false);
      }
    };
    getCMSData();
  }, []);

  useEffect(() => {
    const schemas = generateSellCommercialSchema();
    schemas.forEach((schema, index) => {
      injectSchema(schema, `sell-commercial-schema-${index}`);
    });
    return () => {
      schemas.forEach((_, index) => {
        removeSchema(`sell-commercial-schema-${index}`);
      });
    };
  }, []);

  const renderContent = () => {
    if (loading) {
      return (
        <div className="loading-section">
          <ShimmerPostDetails card cta variant="EDITOR" />
        </div>
      );
    }

    if (error || !Array.isArray(sellCMSData) || sellCMSData.length === 0) {
      return (
        <div className="d-flex align-items-center justify-content-center vh-100">
          <div className="text-center">
            <div className="alert alert-danger" role="alert">
              <h2 className="alert-heading">Unable to Load Content</h2>
              <p>
                {error ||
                  "Sorry, something went wrong while fetching the data. Please try again later."}
              </p>
              <hr />
              <button
                className="btn btn-thm btn-primary"
                onClick={() => window.location.reload()}
              >
                Retry
              </button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <>
        <SellHeroSection cmsData={sellCMSData} type="commercial" />
        <SellHowItWorks cmsData={sellCMSData} type="commercial" />
        <SellContactUs cmsData={sellCMSData} type="commercial" />
        <SellStatsSection cmsData={sellCMSData} type="commercial" />
      </>
    );
  };

  return (
    <>
      <MetaComponent meta={metadata} />
      <div className="d-flex flex-column min-vh-100 sell-commercial-page">
        <CommercialHeader hideSellCTA />
        <MobileMenu />
        <PopupSignInUp />

        <div
          style={{ flex: 1, marginTop: "calc(3.5rem + 1.75vw)" }}
          className="flex-grow-1"
        >
          {renderContent()}
        </div>

        <PageFooter showPartners={true} />
      </div>
    </>
  );
};

export default SellPageCommercial;
